import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EventArgs } from "../../atp-core";

export type AtpTableActionsMenuType = 'Single' | 'Multiple';

export class AtpTableActionsMenu {
  constructor(
    public type: AtpTableActionsMenuType,
    public items?: IAtpTableActionsMenuItem[]
  ) {}
  isDisabled = false;
}

export interface IAtpTableActionsMenuItem {
  name: string;
  icon: string;
  action: (model?: any) => void;
  items: IAtpTableActionsMenuItem[];
  needModel: boolean;
  conditionField?: string;
}

export class AtpTableActionsMenuItem implements IAtpTableActionsMenuItem {
  constructor(
    public name: string,
    public icon: string,
    public action: (model?: any) => void,
    public needModel: boolean = true,
    items?: IAtpTableActionsMenuItem[],
    public conditionField?: string
    ) {
    this.items = items;
  }
  items: IAtpTableActionsMenuItem[];
}

export class AtpCustomTableActionsMenuItem<T> implements IAtpTableActionsMenuItem {
  constructor(action: (value: T, model?: any) => void, public field: string, public icon: string, public needModel: boolean = true) {
    this.action = function (model?: any): void {
      action(this.value, model);
    };
  }

  name: string;
  items: IAtpTableActionsMenuItem[];
  isInvisible: boolean = false;

  protected _value: T;
  get value(): T {
    return this._value;
  }
  set value(value: T) {
    this._value = value;
  }

  action: (model?: any) => void;
}

export class AtpEnabledTableActionsMenuItem extends AtpCustomTableActionsMenuItem<boolean> {
  constructor(action: (value: boolean, model?: any) => void, public activeName?: string, public deactiveName?: string, public fieldString?: string, public activeIcon: string = '', public deactiveIcon: string = '') {
    super(action, fieldString ? fieldString : 'isDisabled', null);
  }

  get value(): boolean {
    return this._value;
  }
  set value(value: boolean) {
    if (value) {
      this.name = this.activeName || 'Активировать';
      this.icon = this.activeIcon;
    }
    else {
      this.name = this.deactiveName || 'Деактивировать';
      this.icon = this.deactiveIcon;
    }
    this._value = value;
  }
}

@Component({
  selector: 'atp-table-actions-menu',
  templateUrl: './atp-table-actions-menu.component.html'
})
export class AtpTableActionsMenuComponent {
  constructor() { }
  @Output() actionEvent = new EventEmitter<{ action: string, model: any }>();

  @Input() actionsMenuModel: AtpTableActionsMenu;
  @Input() model: any;
  localItems = [];

  opened() {
    if (!this.model || !this.actionsMenuModel.items || this.actionsMenuModel.items.length == 0) return;

    const customItems = this.actionsMenuModel.items.filter(x => x instanceof AtpCustomTableActionsMenuItem);

    for (const customItem of customItems) {
      (<AtpCustomTableActionsMenuItem<any>>customItem).value = this.model[(<AtpCustomTableActionsMenuItem<any>>customItem).field];
    }

    // personal actions
    this.localItems = [];
    console.log(this.actionsMenuModel.items);
    if (this.model.actions) {
      for (const action of this.model.actions) {



        this.localItems.push(new AtpTableActionsMenuItem(action.display, action.icon, (model) => {
          this.actionEvent.emit({ action: action.code, model });
        }));
      }
    }
  }
  get items() {
    return [...this.localItems, ...this.actionsMenuModel.items.filter(item => {
      return item.conditionField ? this.model[item.conditionField] : true;
    })];
  }
}

@Component({
  selector: 'atp-table-actions-submenu',
  template: `<button mat-menu-item [matMenuTriggerFor]="submenu">
              <mat-icon>{{actionMenuItem.icon}}</mat-icon>
              <span>{{actionMenuItem.name}}</span>
            </button>
            <mat-menu #submenu="matMenu">
              <button *ngFor="let subitem of actionMenuItem.items" mat-menu-item (click)="subitem.action(model)">
                <mat-icon>{{subitem.icon}}</mat-icon>
                <span>{{subitem.name}}</span>
              </button>
            </mat-menu>`
})

export class AtpTableActionsSubmenuComponent {
  constructor() {
  }

  @Input() actionMenuItem: AtpTableActionsMenuItem;
  @Input() model: any;
}
